import React, { FC } from 'react';
import { Item, ItemDefinition, registry, RenderProps } from '../Item';
import {
  DropdownDefinition,
  QUIZ_TEXT_FILL
} from '~/training/sequence/templates/items';
import styled from '@xstyled/styled-components';
import {
  QuizDropdownProvider,
  useQuizDropdownStore
} from '~/training/sequence/templates/items/quiz/QuizDropdownStore';
import { Card } from '~/ui/card/Card';
import { t } from 'ttag';

interface Props {
  text?: string;
  dropdownItems?: DropdownDefinition;
}

const FlexBlock = styled.divBox`
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  padding-top: 10px;
  gap: md;
  & div {
    display: inline;
    position: relative;
    float: left;
    left: 0px;
  }
  & p {
    display: inline;
    position: relative;
    float: left;
    left: 0px;
  }
  & button {
    display: inline;
    position: relative;
    float: left;
    left: 0px;
  }
`;

export type QuizTextFillDefinition = ItemDefinition<
  typeof QUIZ_TEXT_FILL,
  Props
>;

const AddItemsToTheStore: FC<Props> = props => {
  const { pushItem, items } = useQuizDropdownStore();

  if (props.dropdownItems && items.length == 0) {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    props.dropdownItems.forEach((item: DropdownDefinition) => pushItem(item));
  }

  const showMessage = items.find(item => item.used);

  return showMessage ? (
    <Card
      aria-live="polite"
      p="md"
      m="xxl"
      dangerouslySetInnerHTML={{
        __html: t`In order to continue, please select the correct answer(s) and remove any incorrect answer(s) by clicking on them on desktop or tapping on mobile or tablet.`
      }}
    />
  ) : null;
};

export class QuizTextFill extends Item<typeof QUIZ_TEXT_FILL, Props> {
  protected render({ children, dropdownItems }: RenderProps<Props>) {
    return (
      <QuizDropdownProvider>
        <FlexBlock>{children}</FlexBlock>
        <AddItemsToTheStore dropdownItems={dropdownItems} />
      </QuizDropdownProvider>
    );
  }
}

registry[QUIZ_TEXT_FILL] = QuizTextFill;
